import React, { useEffect, useState } from 'react'
import './Teams.css'
import { Row, Col, Modal, Typography, Checkbox, Space, Table, Tag, Button, Input, Select, notification, List } from 'antd'
import Sider from '../../Courses/Sider'
import { EditOutlined, UsergroupAddOutlined, UserAddOutlined } from '@ant-design/icons';
import axios from 'axios'
import randomstring from 'randomstring';
import { BaseUrl } from '../../Constants/Constants';

const Teams = () => {
    const [Data, setData] = useState([])
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpenLogin, setIsModalOpenLogin] = useState(false);
    const [isAddUsersModalOpen, setIsAddUsersModalOpen] = useState(false);
    const [TeamName, setTeamName] = useState("");
    const [ teamDesc, setTeamDesc ] = useState('')
    const [Email, setEmail] = useState('')
    const [Status, setStatus] = useState([])
    const [StatusAdd, setStatusAdd] = useState(true)
    const [api, contextHolder] = notification.useNotification();
    const [Options, setOptions] = useState({})
    const [Password, setPassword] = useState("")
    const [TeamOptions, setTeamOptions] = useState('')
    const [LoadTable, setLoadTable] = useState(false)
    const [showTable, setshowTable] = useState(false)
    const [teamId, setteamId] = useState('')
    const [currentTeamId, setCurrentTeamId] = useState('')
    const [TeamData, setTeamData] = useState([])
    const [Loading, setLoading] = useState(false);
    const [ manager, setManager ] = useState('');
    const [ managerOption, setManagerOption ] = useState('');
    const [ managerEmail, setManagerEmail ] = useState('');
    const [ managerUserId, setManagerUserId ] = useState('');
    const [showInactive, setShowInactive] = useState(false);
    const [allUsers, setAllUsers] = useState([]);
    const [availableUsers, setAvailableUsers] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [loadingUsers, setLoadingUsers] = useState(false);
    const [userListForModal, setUserListForModal] = useState([]);
    const [searchUserText, setSearchUserText] = useState('');

    const companyId = localStorage.getItem('companyId');

    const showModal = (e) => {
        console.log(e, "recordTeamValues", e.email)
        setTeamName(e.Team_name)
        setEmail(e.email)
        setStatus(e.isActive)
        setIsModalOpen(true);
        setteamId(e.team_id);
        setManager(e.manager_username);
        setManagerEmail(e.manager_mail);
    };
    console.log(TeamName, 'TeamName')
    const generatePassword = () => {
        setPassword(randomstring.generate({
            length: 10,
            charset: 'alphanumeric',
        }))

    };

 

    const openNotificationWithIconWarning = (type) => {
        api['warning']({
            message: "Warning!!!",
            description:
                type,
        });
    };
    const openNotificationWithIconSuccess = (type) => {
        console.log('getsSuccess')
        api['success']({
            message: "Mail sent",
            description:
                type,
        });
    };

    
    const handleOk = () => {

        let body = {
            teamId : teamId,
            teamName : TeamName,
            IsActive : Status, 
            managerMail: managerEmail,
            managerUsername: manager
        }

        axios.post(`${BaseUrl}teams/team_update`, body, {withCredentials:true})
        .then(( res ) => {
            console.log(res.data.statuscode, 'updateTeamDetails');

            if( res.data.statuscode==200 ) {
                setTeamName('')
                setEmail('')
                setStatus(true);
                openNotificationWithIconSuccess('Updated successfully!!!');
                setLoadTable(!LoadTable);
                setIsModalOpen(false);
            }
        })
        .catch(( err ) => console.log(err, "teamUpdateError"))  
        

    };
    const handleCancel = () => {
        setIsModalOpen(false);
        setTeamName('')
        setEmail('')
        setStatus("")
    };
    const showModalLogin = (e) => {
        setIsModalOpenLogin(true);


    };

    console.log(Password, "pass")

    useEffect(() => {
        let userUrl = `${BaseUrl}users`

        axios.get(userUrl, {withCredentials:true})
        .then(( res ) => {
            let managers = res.data.filter( item => item.role === 'manager' )
            
            let options = managers.map( item => ({
                label : item.email,
                value : item.email,
                userId : item.user_id
            }) )
            console.log(options, 'userresponse');

            setManagerOption(options);

        })

    }, [])

    const handleOkAdd = () => {
        setLoadTable(false)
        setLoading(true)
        generatePassword()
        let Body = {
            teamName: TeamName,
            companyid: companyId,
            userid: managerUserId,
            IsActive: StatusAdd,
            managerMail: managerEmail,
            managerUsername: manager
        }
        axios
            .post(`${BaseUrl}teams/create`, Body, {withCredentials:true})
            .then((res) => {
                console.log(res, "log")
                if (res.data.status === 204) {
                    setLoading(false)
                    openNotificationWithIconWarning('Invalid ');
                }
                else {
                    openNotificationWithIconSuccess("Team Added Sucessfully")
                    setLoadTable(true)
                    setIsModalOpenLogin(false);

                }
            })
            .catch((err) => {
                // openNotificationWithIconWarning('Invalid Credentials');
                console.log(err, "log")
                if (err.status == 409) {
                    setLoading(false)
                    setIsModalOpenLogin(false);
                    openNotificationWithIconWarning('User Already exist');
                }
            })
    };

    const handleManagerMail = (val, e) => {
            console.log(val, 'managerMailId', e.userId)
            setManagerEmail(val);
            setManagerUserId(e.userId)
    }

    const handleCancelAdd = () => {
        setIsModalOpenLogin(false);
    };
    const OpenTeamview = (e) => {
        console.log(e, "team")
        setTeamName(e.Team_name)
        setCurrentTeamId(e.team_id)
        setLoading(true)

        let body = {
            teamid: e.team_id
        }
        axios
            .post(`${BaseUrl}users/findone`, body, {withCredentials:true})
            .then((res) => {
                console.log(res.data.data.users, 'teamss')
                setTeamData(res.data.data.users)
                setshowTable(true)
                setLoading(false)
            })
            .catch((err) => {
                console.log(err)
                setLoading(false)
            })
    }

    const showAddUsersModal = () => {
        setIsAddUsersModalOpen(true);
        fetchAvailableUsers();
    };

    const fetchAvailableUsers = () => {
        setLoadingUsers(true);
        
        // Fetch both users and teams to filter out inactive teams
        Promise.all([
            axios.get(`${BaseUrl}users`, {withCredentials:true}),
            axios.get(`${BaseUrl}teams`, {withCredentials:true})
        ])
            .then(([usersRes, teamsRes]) => {
                console.log(usersRes.data, 'allUsers');
                console.log(teamsRes.data, 'allTeams');
                
                setAllUsers(usersRes.data);
                
                // Get active team IDs
                const activeTeamIds = teamsRes.data
                    .filter(team => team.isActive === true)
                    .map(team => team.team_id);
                
                // Get current team user IDs
                const teamUserIds = TeamData.map(user => user.user_id);
                
                // Filter out managers and users from inactive teams, but include all other users (including current team members)
                const filtered = usersRes.data.filter(user => {
                    // Exclude managers
                    if (user.role === 'manager') return false;
                    
                    // Exclude users from inactive teams
                    // Handle both cases: team_id as object or as string
                    let userTeamId = null;
                    if (user.team_id) {
                        if (typeof user.team_id === 'object' && user.team_id.team_id) {
                            userTeamId = user.team_id.team_id;
                        } else if (typeof user.team_id === 'string') {
                            userTeamId = user.team_id;
                        }
                    }
                    
                    // If user has a team_id, it must be an active team
                    if (userTeamId && !activeTeamIds.includes(userTeamId)) {
                        return false;
                    }
                    
                    // Include users without a team or with active teams (including current team members)
                    return true;
                });
                
                // Create user list with checkbox state
                const userList = filtered.map(user => ({
                    user_id: user.user_id,
                    username: user.username,
                    email: user.email,
                    isInTeam: teamUserIds.includes(user.user_id)
                }));
                
                setUserListForModal(userList);
                
                // Initialize selectedUsers with current team members
                setSelectedUsers(teamUserIds);
                
                // Keep availableUsers for backward compatibility if needed
                const userOptions = filtered.map(user => ({
                    label: `${user.username} (${user.email})`,
                    value: user.user_id,
                    username: user.username,
                    email: user.email
                }));
                
                setAvailableUsers(userOptions);
                setLoadingUsers(false);
            })
            .catch((err) => {
                console.log(err, 'fetchUsersError');
                setLoadingUsers(false);
                openNotificationWithIconWarning('Failed to fetch users');
            });
    };

    const handleUserSelection = (selectedValues) => {
        setSelectedUsers(selectedValues);
    };

    const handleUserCheckboxChange = (userId, checked) => {
        if (checked) {
            // Add user to selection
            setSelectedUsers(prev => [...prev, userId]);
        } else {
            // Remove user from selection
            setSelectedUsers(prev => prev.filter(id => id !== userId));
        }
    };

    const handleAddUsersToTeam = () => {
        setLoading(true);
        
        // Use the new API endpoint to add users to team
        const body = {
            team_id: currentTeamId,
            user_ids: selectedUsers
        };

        axios.post(`${BaseUrl}teams/add-users`, body, {withCredentials:true})
            .then((res) => {
                console.log(res.data, 'addUsersToTeamResults');
                
                if (res.data.statuscode === 200 || res.data.status === 'SUCCESS') {
                    const addedCount = selectedUsers.length;
                    openNotificationWithIconSuccess(`Team updated successfully. ${addedCount} user(s) in team.`);
                    setSelectedUsers([]);
                    setIsAddUsersModalOpen(false);
                    setSearchUserText('');
                    
                    // Refresh the team user list
                    let refreshBody = {
                        teamid: currentTeamId
                    };
                    return axios.post(`${BaseUrl}users/findone`, refreshBody, {withCredentials:true});
                } else {
                    throw new Error(res.data.message || 'Failed to update team users');
                }
            })
            .then((res) => {
                if (res) {
                    setTeamData(res.data.data.users);
                }
                setLoading(false);
            })
            .catch((err) => {
                console.log(err, 'addUsersToTeamError');
                setLoading(false);
                const errorMessage = err.response?.data?.message || err.message || 'Failed to update team users';
                openNotificationWithIconWarning(errorMessage);
            });
    };

    const handleCancelAddUsers = () => {
        setIsAddUsersModalOpen(false);
        setSelectedUsers([]);
        setSearchUserText('');
    };

    // Filter users based on search text
    const filteredUserList = userListForModal.filter(user => {
        if (!searchUserText) return true;
        const searchLower = searchUserText.toLowerCase();
        return user.username.toLowerCase().includes(searchLower) || 
               user.email.toLowerCase().includes(searchLower);
    });
    const columns = [
        // {
        //     title: 'S.No',
        //     dataIndex: 'key',
        //     key: 'key',
        // },
        {
            title: 'Team Name',
            dataIndex: 'Team_name',
            key: 'Team_name',
            render: (text, record) => <p onClick={(e) => OpenTeamview(record)} className='NameTxtTeam'>{text}</p>,
        },
        {
            title: 'Manager',
            dataIndex: 'manager_username',
            key: 'manager_username',
            align: 'center'
            // render: (text, record) => <p onClick={(e) => OpenTeamview(record)} className='NameTxtTeam'>{text}</p>,
        },
        {
            title: 'Manager Email',
            dataIndex: 'manager_mail',
            key: 'manager_mail',
            align: 'center'
            // render: (text, record) => <p onClick={(e) => OpenTeamview(record)} className='NameTxtTeam'>{text}</p>,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <EditOutlined className='Edit' onClick={(e) => {
                        console.log(record, 'teamRecord');

                        showModal(record)}} />
                </Space>
            ),
        },
    ];

    const usercolumns = [
        {
            title: 'S.No',
            dataIndex: 'key',
            key: 'key',
            render: (_, record, index) => <p>{index + 1}</p>,
        },
        {
            title: 'User Name',
            dataIndex: 'username',
            key: 'username',
            render: (text, record) => <p >{text}</p>,
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            render: (text, record) => <p >{text}</p>,
        },

    ];


    let companyData = () => {
        axios
            .get(`${BaseUrl}company`, {withCredentials:true})
            .then((res) => {
                console.log(res.data, "options")
                setOptions(res.data)
                const transformedArray = res.data.map(item => ({
                    label: item.company_mail.toUpperCase(),
                    value: item.company_id,
                }));
                setOptions(transformedArray)
                console.log(transformedArray, "transformedArray")
            })
            .catch((err) => {

            })
    }
    console.log(Data, 'TeamData')

    let teamdata = () => {
        setLoading(true)
        axios
            .get(`${BaseUrl}teams`, {withCredentials:true})
            .then((res) => {
                console.log(res.data, "optionsteam")
                setData(res.data)
                setOptions(res.data)
                const transformedArray = res.data.map(item => ({
                    label: item.Team_name.toUpperCase(),
                    value: item.team_id,
                }));
                setTeamOptions(transformedArray)
                console.log(transformedArray, "transformedArrayTeam")
                setLoading(false)
            })
            .catch((err) => {
                setLoading(false)
            })
    }
    useEffect(() => {
        companyData()
        teamdata()
    }, [LoadTable])
    const handleChange = (value) => {
        console.log(`selected ${value}`);
        setStatus(value)
    };
    const handleChangeTeam = (value) => {
        console.log(`selected ${value}`);
        setteamId(value)
    };

    const filteredTeams = showInactive
    ? Data.filter(Data => !Data.isActive) // Show inactive Datas
    : Data.filter(Data => Data.isActive);

    const handleCheckboxChange = (e) => {
        setShowInactive(e.target.checked);
      };

    return (
        <div className='Users-main'>
            {contextHolder}
            <div className='ModalDiv'>
                <Modal title="Edit Team" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                    <p style={{ marginTop: 20 }} className='Title' >Team Name</p>
                    <Input placeholder="Team Name"
                        onChange={(e) => setTeamName(e.target.value)}
                        value={TeamName}
                        className='EditInput' />
                    <p className='Title' >Manager Name</p>
                    <Input placeholder="Manager Name"
                        value={manager}
                        onChange={(e) => setManager(e.target.value)}
                        className='EditInput' />
                        <p className='Title' >Manager Email Id</p>
                    <Input placeholder="Manager Mail Id"
                        value={managerEmail}
                        onChange={(e) => setManagerEmail(e.target.value)}
                        className='EditInput' />
                    <p className='Title' >Status</p>
                    <Select
                        defaultValue={Status}
                        value={Status}
                        className='EditInput'
                        onChange={handleChange}
                        options={[
                            {
                                value: true,
                                label: 'Active',
                            },
                            {
                                value: false,
                                label: 'Inactive',
                            }
                        ]}
                    />

                </Modal>
                <Modal title="Add Team" open={isModalOpenLogin} onOk={handleOkAdd} onCancel={handleCancelAdd}>
                    <p style={{ marginTop: 20 }} className='Title' >Team Name</p>
                    <Input placeholder="Team Name"
                        // defaultValue={TeamName}
                        // value={TeamName}
                        onChange={(e) => setTeamName(e.target.value)}
                        className='EditInput' />
                        <p style={{ marginTop: 20 }} className='Title' >Manager Name</p>
                    <Input placeholder="Manager Name"
                        // defaultValue={TeamName}
                        // value={TeamName}
                        onChange={(e) => setManager(e.target.value)}
                        className='EditInput' />
                        <p style={{ marginTop: 20 }} className='Title' >Manager Email</p>
                    {/* <Input placeholder="Manager Email"
                        onChange={(e) => setManagerEmail(e.target.value)}
                        className='EditInput' /> */}
                        <Select options={managerOption} 
                        style={{ width: '100%', height: '50px' }}
                        onChange={handleManagerMail}
                        placeholder='Select Manager Email'
                        />
                    {/* <p className='Title' >Assign members</p> */}
                    {/* <Select
                        // defaultValue={Status}
                        mode="multiple"
                        allowClear
                        placeholder="Select Employees"
                        className='EditInput'
                        onChange={handleChange}
                        options={Options}
                    /> */}
                    {/* <p className='Title' >Map Company</p>
                    <Select
                        defaultValue={Status}
                        value={Status}
                        placeholder="Select Company Name"
                        className='EditInput'
                        onChange={handleChange}
                        options={Options}
                    /> */}


                    <p style={{ marginTop: 20 }} className='Title' >Team Description</p>
                    <Input placeholder="Team Description"
                        // defaultValue={TeamName}
                        // value={TeamName}
                        onChange={(e) => setTeamDesc(e.target.value)}
                        className='EditInput' />

                    {/* <p style={{ marginTop: 20 }} className='Title' >Team Manager  <span style={{ fontSize: "10px", color: "grey" }}>(User to whom all the escalation mails will be sent)</span></p>
                    <Input placeholder="Team Manager"
                        // defaultValue={TeamName}
                        // value={TeamName}
                        onChange={(e) => setTeamName(e.target.value)}
                        className='EditInput' /> */}


                    <p className='Title' >Status</p>
                    <Select
                        // defaultValue={true}
                        defaultValue={true}
                        // value={StatusAdd}
                        // value={Status}
                        className='EditInput'
                        onChange={handleChange}
                        options={[
                            {
                                value: true,
                                label: 'Active',
                            },
                            {
                                value: false,
                                label: 'Inactive',
                            }
                        ]}
                    />


                </Modal>
                <Modal 
                    title="Add Users to Team" 
                    open={isAddUsersModalOpen} 
                    onOk={handleAddUsersToTeam} 
                    onCancel={handleCancelAddUsers}
                    width={700}
                    okText="Update Team"
                >
                    <p style={{ marginTop: 20, marginBottom: 10 }} className='Title'>Select Users for Team</p>
                    
                    {/* Search Input */}
                    <Input
                        placeholder="Search by name or email"
                        value={searchUserText}
                        onChange={(e) => setSearchUserText(e.target.value)}
                        style={{ marginBottom: 16 }}
                        allowClear
                    />
                    
                    {loadingUsers ? (
                        <div style={{ textAlign: 'center', padding: '20px' }}>
                            <p>Loading users...</p>
                        </div>
                    ) : (
                        <>
                            <div style={{ 
                                maxHeight: '400px', 
                                overflowY: 'auto', 
                                border: '1px solid #d9d9d9', 
                                borderRadius: '4px',
                                padding: '8px'
                            }}>
                                {filteredUserList.length === 0 ? (
                                    <p style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
                                        No users found
                                    </p>
                                ) : (
                                    <List
                                        dataSource={filteredUserList}
                                        renderItem={(user) => (
                                            <List.Item style={{ padding: '8px 0', borderBottom: '1px solid #f0f0f0' }}>
                                                <Checkbox
                                                    checked={selectedUsers.includes(user.user_id)}
                                                    onChange={(e) => handleUserCheckboxChange(user.user_id, e.target.checked)}
                                                >
                                                    <span style={{ marginLeft: 8 }}>
                                                        <strong>{user.username}</strong> ({user.email})
                                                    </span>
                                                </Checkbox>
                                            </List.Item>
                                        )}
                                    />
                                )}
                            </div>
                            <p style={{ marginTop: 10, color: '#666', fontSize: '12px' }}>
                                {selectedUsers.length} user(s) selected
                            </p>
                        </>
                    )}

                </Modal>
            </div>

            <div className="addCourceandHeading">
        <h2></h2>
        {/* <Button
          onClick={() => setCourseModal(true)}
          className="addCourseButton">Add Course</Button> */}
          <Checkbox onChange={handleCheckboxChange}>Show Inactive Teams</Checkbox> 
      </div>

            {
               !showInactive && showTable ?
                    <>
                        <p className='back' onClick={() => setshowTable(false)}>
                            Team/{TeamName}
                        </p>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                            <h2>
                                {TeamName} Team Users List
                            </h2>
                            <Button
                                onClick={showAddUsersModal}
                                className='ADD'
                                type='primary'
                                icon={<UserAddOutlined />}
                            >
                                Add Users
                            </Button>
                        </div>
                        {
                            Loading ?
                                <div className='Loader' >

                                    <img src='Loader\Ellipsis-2.9s-200px.svg'>
                                    </img>
                                </div>
                                :

                                <Table columns={usercolumns}
                                    dataSource={TeamData}
                                />
                        }
                    </>
                    :
                    <>
                        <h2>
                            Manage Teams
                        </h2>
                        <Button
                            onClick={showModalLogin}
                            className='ADD'
                            type='primary'
                        >
                            Add Team <UsergroupAddOutlined />
                        </Button>
                        {
                            Loading ?
                                <div className='Loader' >

                                    <img src='Loader\Ellipsis-2.9s-200px.svg'>
                                    </img>
                                </div>
                                :
                                <Table  pagination={{
                                    position: ['bottomCenter'],
                                    showSizeChanger: false,
                                  }}  columns={columns} dataSource={filteredTeams} />
                        }
                    </>
            }
        </div>
    )
}


export default Teams